<template>
	<el-dialog v-model="innerVisible" :close-on-click-modal="false"  title="物料选择" width="88%" @closed="closeDeal">
    <!-- @opened="openedInit" -->
    <div class="assemble-choose-material-modal-content">
			<div class="modal-content-top">
				<el-form :model="query" label-width="100px"><el-row>
					<el-col :span="4">
					  <el-form-item label="品号:">
					    <el-input v-model="query.Code" clearable placeholder="请输入品号" />
					  </el-form-item>
					</el-col>
					<el-col :span="4">
					  <el-form-item label="容器编号:">
					    <el-input v-model="query.ContainerCode" clearable placeholder="请输入容器编号" />
					  </el-form-item>
					</el-col>
					<el-col :span="4">
					  <el-form-item label="库位编号:">
					    <el-input v-model="query.LocationCode" clearable placeholder="请输入库位编号" />
					  </el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="项目编号:">
							<el-input v-model="query.ProjectCode" clearable placeholder="请输入项目编号" />
						</el-form-item>
					</el-col>
					<el-col :span="4">
					  <el-form-item label="规格型号:">
					    <el-input v-model="query.SpecificationModel" clearable placeholder="请输入规格型号" />
					  </el-form-item>
					</el-col>
					<el-col :span="4">
					  <el-form-item label-width="20px">
					    <el-button type="primary" icon="el-icon-search" @click="newList">查询</el-button>
					    <el-button icon="el-icon-refresh-right" @click="onReset">重置</el-button>
            </el-form-item>
					</el-col>
				</el-row></el-form>
			</div>
			<div class="modal-content-list">
				<div class="list-padding">
					<div>
						<!-- :row-class-name="rowClassName" -->
            <!-- @scroll="handleScroll" -->
            <!-- @wheel="handleMouseWheel" -->
						<!-- <el-table :data="list" border row-key="id" ref="choosetable" scrollbar-always-on
              :height="queryHidden?630:570" 
              v-loading="isLoading"  
              element-loading-text="拼命加载中..."
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)"
            > -->
              <el-table :data="list" border style="width: 100%;" row-key="id" ref="choosetable" v-loading="isLoading" :height="queryHidden?630:570"
                @selection-change="handleSelectionChange" :default-sort="{ prop: 'isCheck', order: 'ascending' }">
              <el-table-column align="center" width="60" type="selection" reserve-selection />
              <el-table-column label="序号" width="60" align="center" type="index" />							
							<el-table-column label="项目编号" prop="projectCode" align="center" width=""/>
							<el-table-column label="品号" prop="code" align="center" width=""/>
							<el-table-column label="品名" prop="name" align="center" width="250" />
							<el-table-column label="规格型号" prop="specificationModel" align="center" width="350"/>
							<el-table-column label="单位" prop="unit" align="center" width="60"/>
							<el-table-column label="容器编号" prop="containerCode" align="center" width=""/>
							<el-table-column label="库位编号" prop="locationCode" align="center" width=""/>
							<el-table-column label="出库数" width="" align="center">
							  <template #default="scope">
									<el-input-number v-model="scope.row.orderQuantity" :min="0" :max="scope.row.currentQuantity" size="small" />
							  </template>
							</el-table-column>
							<el-table-column
								label="库存数"
								prop="currentQuantity"
								align="center"
								width=""
							/>
						</el-table>
          </div>    
        </div>
      </div>
      <div style="display: flex; justify-content: flex-end; padding-top: 8px">
        <el-pagination
          :background="true" v-loading="isLoading"
          :total="total"
          :page-sizes="[10, 20, 100,500,1000]"
          v-model:current-page="queried.PageNo"
          v-model:page-size="queried.PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="onBtnClose">取 消</el-button>
        <el-button :disabled="!showChoosen && choosen.length === 0">已选物料({{ choosen.length }})</el-button>
        <el-button :disabled="choosen.length === 0 || isLoading" type="primary" @click="onOk">确 定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import {
  defineEmits,
  ref,
  reactive,
  watch,
  toRefs,
  getCurrentInstance,onMounted,onBeforeUnmount,nextTick
} from "vue";
import {ElLoading } from 'element-plus';
import { getStorageInfoShelvesList } from "@/service/main/warehouse";
import {
  getManualOutstock,
  StockListPage
} from "@/service/main/invoices/allocateOrder";
import { localStatus } from "../../switchCase";
const defaultQuery = {
  ContainerCode: "",
  LocationCode: "",
  ProjectCode: "",
  Code: "",
  AreaID: -10
};
const pagination = {
  PageNo: 1,
  PageSize: 500
};
const emits = defineEmits(["update:visible", "callback"]);

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  projectCode: {
    type: String,
    default: ""
  },
  chooseList: {
		type: Array,
		default: ()=>{
			return []
		}
	},
});
const { visible, projectCode,chooseList } = toRefs(props);

const innerVisible = ref(false);
const isLoading = ref(false)

const queryHidden = ref(true);
const query = reactive({ ...defaultQuery });
const queried = reactive({ ...pagination });
const selectOptions = reactive({
  areas: []
});
const list = ref([]);
const total = ref(0);
const choosen = ref([]);
const recordSelection = ref([]); // 选择记录的数据
const recordMoment = ref([]); // 当前页的数据
const showChoosen = ref(false);

// watch(
//   visible,
//   function (newVal) {
//     if (innerVisible.value !== newVal) {
//       innerVisible.value = newVal;
//     }
//   },
//   { immediate: true }
// );
// watch(innerVisible, function (newVal) {
//   if (visible.value !== newVal) {
//     emits("update:visible", newVal);
//   }
// });

const closeDeal = function () {
  // choosetable.value.clearSelection() // 清除选择
  list.value = [];
  total.value = 0;
  choosen.value = [];
  showChoosen.value = false;
};

const onBtnClose = function () {
  selfClose();
};

const selfClose = function () { 
  innerVisible.value = false;
  showChoosen.value = false;
  isLoading.value = false
  choosen.value = [];
  list.value = [];
};

const openedInit = function () {
  isLoading.value = true
  list.value = []
  //console.log('projectCode',projectCode.value)
  query.ProjectCode = projectCode.value;
  getAreaOptions();
  reset();
};

const getAreaOptions = function () {
  if (selectOptions.areas.length <= 0) {
    getStorageInfoShelvesList().then((res) => {
      let arr = res.data || [];
      if (arr.length > 0) {
        arr.unshift({
          id: -10,
          areaName: "全部"
        });
      }
      selectOptions.areas = arr;
    });
  }
};

const onQuery = function () {
  innerVisible.value = true;
  query.ProjectCode = projectCode.value;
  newList();
};

const onReset = function () {
  reset();
};
// 打开弹窗
const newList = async () => {
  for (let name in query) {
    queried[name] = query[name];
  }
  for (let name in pagination) {
    queried[name] = pagination[name];
  }
  getList();
};
// const newList = function () {
//   innerVisible.value = true;
//   console.log('innerVisible.value',innerVisible.value)
//   for (let name in query) {
//     queried[name] = query[name];
//   }
//   for (let name in pagination) {
//     queried[name] = pagination[name];
//   }
//   getList();
// };

const choosetable = ref();
// const handleQuery = async () => {
// 	loading.value = true;
// 	try {
// 		var { data } = await MaterialPage(Object.assign(queryParams.value, tableParams.value));
// 		console.log(data);
// 		listAll.value  = [...data.result?.items] ?? [];
// 		list.value=[...listAll.value];
// 		tableParams.value.total = data.result?.total;
// 		// setSelectRow()
// 		if(props.chooseList.length > 0){
// 			materialTableRef.value.clearSelection();
// 			var idsGwc = [...new Set(props.chooseList.filter((item: any) => item.id).map((item: any) => item.id))];
// 			recordSelection.value = idsGwc.slice(); // 创建idsGwc的副本
// 			recordMoment.value = idsGwc.slice(); // 创建idsGwc的副本
// 			toggleSelectionFj(list.value,recordMoment.value);				
// 		}
// 	} catch (error) {
// 		console.log(error);
// 	}
// 	loading.value = false;
// };

const getList = function(val){
  list.value = []
  isLoading.value = true 
	StockListPage(queried).then((res) => {   
    res.data.rows.forEach(vo=>{
      vo.orderQuantity = vo.currentQuantity
    })
    list.value = res.data.rows
		total.value = res.data.totalPage
    // console.log('Array.isArray(props.chooseList)',Array.isArray(props.chooseList))
    // console.log('props.chooseList.length',props.chooseList.length)
    // console.log('props.chooseList',props.chooseList)
    // console.log('chooseList',chooseList.value)
    //==============ly复选框记忆功能添加==============
    // nextTick(() => {
      if (!val) {
        // recordMoment.value = [];
        if (props.chooseList.length > 0) {
            //只要弹框打开就清空所有选中项目
          choosetable.value.clearSelection();
          var idsGwc = [...new Set(props.chooseList.filter(item => item.id).map(item => item.id))];
          console.log('idsGwc',idsGwc)
          recordSelection.value = idsGwc.slice(); // 创建idsGwc的副本
          recordMoment.value = idsGwc.slice(); // 创建idsGwc的副本
          toggleSelectionFj(list.value, recordSelection.value);
        } else {
          choosetable.value.clearSelection();
          recordSelection.value = [];
        }
      } else {
        toggleSelectionFj(list.value, recordSelection.value);
      }
    // }); // 等待 DOM 更新，再执行下面的代码
    console.log('recordSelection.value',recordSelection.value)
    console.log('recordMoment.value',recordMoment.value)
    //===============ly复选框记忆功能添加==============
		showChoosen.value = true;
    isLoading.value = false
	}).catch((err)=>{
		console.log(err)
    isLoading.value = false
	})
}
//2传入数组，并批量选中， 调用toggleSelection([tableData[1], tableData[2]])
const toggleSelection = function(rows) {
	if (rows) {
		rows.forEach(row=> {
			choosetable.value.toggleRowSelection(row);
		});
	} else {
		// choosetable.value.clearSelection();
	}
};
// ==3过滤以后 再调用批量选中
const toggleSelectionFj = function(tableDataArr, gwcArrIds) {
	// 购物车元素在弹框列表中存在
	var arrRows = tableDataArr.filter(item => gwcArrIds.includes(item.id));
	console.log('arrRows',arrRows)
	// 这个 arrRows 里面的元素，再 selectData 中不存在，调用方法 toggleSelection
	var arrRowsNotSelect = arrRows.filter(item => !choosen.value.some(selectedItem => selectedItem.id === item.id));
	if (arrRowsNotSelect.length > 0) {
		toggleSelection(arrRowsNotSelect);
	}
};
const getCancelGwcIds = function()  {
	//recordMoment 比 recordSelection 多出来的元素
	return recordMoment.value.filter(item => !recordSelection.value.includes(item));
};

const reset = function () {
  for (let name in defaultQuery) {
    query[name] = defaultQuery[name];
  }
  newList();
};

const handleSizeChange = function (pageSize) {
  queried.PageNo = 1;
  queried.PageSize = pageSize;
  getList(1);
};

const handleCurrentChange = function (page) {
  queried.PageNo = page;
  getList(1);
};

const handleSelectionChange = (val) => {
  console.log('已勾选',val)
  choosen.value = val.filter((item, index) => {  //已选项去重
		return val.findIndex(i => i.id === item.id ) === index;
	});
  console.log('已勾选choosen.value',choosen.value)
	var arrGwcDqyRows = list.value.filter(item => recordMoment.value.includes(item.id));
	console.log('当前列表中在购车中存在的:', arrGwcDqyRows.length);
	if (arrGwcDqyRows.length > 0) {
		arrGwcDqyRows.forEach(row => {
			const itemNow = choosen.value.find(item => item.id == row.id);
			if (itemNow) {
				//recordSelection 就添加
				const index = recordSelection.value.indexOf(row.id);
				if (index == -1) {
					recordSelection.value.push(row.id);
				}
			} else {
				//recordSelection 就删除
				const index = recordSelection.value.indexOf(row.id);
				if (index !== -1) {
					recordSelection.value.splice(index, 1);
				}
			}
		});
	}
};



const onOk = function () {
  isLoading.value = true 
  setTimeout(() => {       
    var cancelGwcIds = getCancelGwcIds();
    // console.log('cancelGwcIds',cancelGwcIds)
    emits("callback", choosen.value, cancelGwcIds);
    selfClose();
  }, 3000);
};
defineExpose({ newList,onQuery });
</script>

<style lang="less" scoped>

::deep.el-table__body-wrapper {
  overflow-y: auto !important;
}
::deep(.el-table.headerSticky){
    overflow: visible;
	    .el-table__header-wrapper{    
			position: sticky;
			z-index: calc(var(--el-table-index) + 2);
			top: 59px;
		}
}
.assemble-choose-material-modal-content {
  height: 80vh;
  display: flex;
  flex-direction: column;
  .modal-content-top {
    padding: 20px 16px 0 16px;
    flex-shrink: 0;
  }
  .modal-content-list {
    flex-grow: 1;
    height: 1px;
    overflow: auto;
    .list-padding {
      padding: 0 16px;
    }
  }
}

</style>